module.exports = require("./br.d.ts");